import { connect } from 'react-redux'
import { sagaActions } from '../../../../sagas'
import SettingsGeneral from './SettingsGeneral'

export default connect(
  (state, props) => {
    return {
      settings: state['view-home'].settings,
      license: state.kanbo.license,
      version: state.kanbo.version.version
    }
  },
  {
    requestChangeSettings: sagaActions.requestChangeSettings
  }
)(SettingsGeneral)
